export default "assets/images/icons/marker-bce3e533.svg";